import React from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";
import { CheckCircle2, ArrowLeft } from "lucide-react";

// Thank-you page is Spanish-only per requirements.
export default function ThankYou() {
  return (
    <main id="main-content" className="thankyou-page" data-testid="page-thankyou">
      <div className="thankyou-page__inner">
        <Link to="/" className="thankyou-page__brand" aria-label="Geolitio">
          <Logo />
        </Link>
        <div className="thankyou-page__card">
          <div className="thankyou-page__icon" aria-hidden="true">
            <CheckCircle2 size={44} />
          </div>
          <span className="eyebrow">Solicitud recibida</span>
          <h1>¡Gracias por contactarnos!</h1>
          <p>
            Hemos recibido su solicitud de acceso a Geolitio. Un analista revisará el mensaje y le responderá
            dentro de las próximas 24 horas hábiles, de lunes a viernes en horario de Argentina (UTC−3).
          </p>
          <p className="thankyou-page__note">
            Mientras tanto, puede volver al inicio para explorar los sectores cubiertos por la plataforma.
          </p>
          <Link to="/" className="btn btn--primary" data-testid="thankyou-home">
            <ArrowLeft size={16} aria-hidden="true" />
            <span>Volver al inicio</span>
          </Link>
        </div>
      </div>
    </main>
  );
}
